import { LabelMode } from "./../../../../utils/label-mode.enum";
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, signal } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MonitorService } from "src/app/services/api/monitor.service";
import { SharedModule } from "src/shared/shared.module";
import { AuthService } from "../../auth";
import { debounceTime, forkJoin, Observable } from "rxjs";
import { ParentCourseService } from "src/app/services/api/parent-course.service";
import { environment } from "src/environments/environment";
import { ParentCourse } from "src/app/services/model/parent-course.model";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { MatDialog } from "@angular/material/dialog";
import { AssignCourseComponent } from "./dialogs/assign-course/assign-course.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-parent-courses",
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbTooltipModule,
    TranslateModule,
  ],
  templateUrl: "./parent-courses.component.html",
  styleUrl: "./parent-courses.component.scss",
})
export class ParentCoursesComponent implements OnInit {
  #fb = inject(FormBuilder);
  #parentCourseService = inject(ParentCourseService);
  #monitorService = inject(MonitorService);
  #authService = inject(AuthService);
  #dialog = inject(MatDialog);

  currentUser = this.#authService.currentUser()?.user;
  isStudent = signal<boolean>(this.currentUser?.role.id === 2);
  parentCourses = signal<ParentCourse[]>([]);
  monitorStudent = this.#monitorService.monitorStudent;

  isLoading = signal(true);

  form: FormGroup;
  LabelMode = LabelMode;

  fileUrl = environment.apiFileUrl;

  ngOnInit(): void {
    this.buildForm();
    // this.fetchData();
  }

  buildForm() {
    this.form = this.#fb.group({
      keywords: [null],
    });
    this.form
      .get("keywords")
      ?.valueChanges.pipe(debounceTime(500))
      .subscribe((val) => {
        this.fetchData();
      });
  }

  _setLoading(value: boolean, time: number = 500) {
    setTimeout(() => {
      this.isLoading.update((_) => value);
    }, time);
  }

  async fetchData() {
    const params = this.form.getRawValue();
    this.isLoading.update(() => true);

    let serviceArray = [
      this.#parentCourseService.getParentCourses(params) as Observable<any>,
      this.#parentCourseService.getAssignCourses(params) as Observable<any>,
    ];

    forkJoin(serviceArray).subscribe({
      next: ([parent_course, assign_course]) => {
        parent_course = parent_course.filter(
          (i: ParentCourse) => i.amount! > 0
        );
        this.parentCourses.update(() => parent_course.concat(assign_course));
      },
      error: (error) => {},
      complete: () => {
        this._setLoading(false);
      },
    });
  }

  open(value: ParentCourse) {
    const dialogRef = this.#dialog.open(AssignCourseComponent, {
      width: "640px",
      disableClose: false,
      autoFocus: false,
      data: value,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isLoading.update(() => true);
        this.fetchData();
      }
    });
  }
}
